var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "users_list mt-3" }, [
    _c(
      "ul",
      { staticClass: "user_list_to_insert" },
      _vm._l(_vm.group_list, function (item, index) {
        return _c(
          "li",
          {
            staticClass: "border cursor-pointer shadow-1 mt-1 mb-2",
            class: _vm.group_class(item),
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.set_active(item, index)
              },
            },
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "user_profile bg-gradient-primary bd-callout position-relative px-2 p-1",
                class: _vm.group_class_bd(item),
              },
              [
                _c("div", { staticClass: "d-flex flex-row pt-2 pb-1" }, [
                  _c("div", { staticClass: "user_attrib ml-3" }, [
                    _c(
                      "div",
                      { staticClass: "name d-block fw-700 text-dark" },
                      [_vm._v(_vm._s(item.title))]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "company small text-dark" }, [
                      _vm._v(_vm._s(item.uniq_id)),
                    ]),
                  ]),
                ]),
              ]
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }